import React, { useState } from 'react'
import Check from '../../assets/images/check-true.jpeg'
import { Up } from '../../assets/svgs/Up'
import { Down } from '../../assets/svgs/Down'
import Checkbox from '../Checkbox'
import Button from '../Button'
import './style.scss'

export default function ButtonToogle({ information, openModal, promotion }) {
	const [informationOpen, setInformationOpen] = useState(false)
	const [icon, setIcon] = useState(false)
	const [checkTerm, setCheckTerm] = useState(false)

	const openInformations = () => {
		setInformationOpen(!informationOpen)
		setIcon(!icon)
	}

	const disableBtn = () => {
		setCheckTerm(!checkTerm)
	}

	return (
		<>
			{
				<div id="home" className="container-toogle calibri">
					<button onClick={openInformations} className="btn-toogle">
						<div className="texts">
							<p>{information.btnText1}</p>
							<span>{information.btnText2}</span>
						</div>
						<div className="icon">
							{icon ? <Up /> : <Down />}
						</div>
					</button>
					<div className={`${!informationOpen && 'dn'} informations`}>
						<div className="initial-text">
							<p>{information.title1}</p>
							<div className="description">{information.title2}</div>
						</div>
						{
							information.btnText1 === 'MAIS CONTROLE' && (
								<div className="divisor">
									<hr />
								</div>
							)
						}
						<div className="table">
							<span>{information.textTitleTable}</span>
							<p>{information.textTitleTable2}</p>
						</div>
						<table>
							{
								information.table.map(inform => (
									<tr className="information-table" key={inform.campo}>
										<th>{inform.campo}</th>
										<th>{inform.campo2 === 'Check' ? 
											(
												<div className="img-container">
													<img alt="check" width="100%" height="100%" src={Check} />
												</div>
											)
											: inform.campo2}</th>
									</tr>
								))
							}
						</table>

						<div className="actions">
							<div className="checkbox-container">
								<Checkbox onChange={disableBtn}/>
								<span>Estou ciente que, ao prosseguir, aceito os <span className="underline" onClick={openModal}>termos e condições</span> da campanha</span>
							</div>
							<div className="container-btn">
								<Button disabled={!checkTerm} text={information.btnText} onClick={promotion} />
							</div>
						</div>
					</div>
				</div>
			}
		</>
	)
}